export default __webpack_public_path__ + "static/char-thumb-34-188477c57eb190c42fba564dc806e46e.png";